<nb-toggle [status]='status' [labelPosition]='labelPos' (change)="checkstatus()"> {{ label }}</nb-toggle>